// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Page components
import UploadFileForm from "./uploadFileForm";
import { ImportActiveJobProvider } from "../../../../../contexts/contextImportJob";
import {
  useStartCountryDemoImportJob,
  useStartCountryInfoImportJob,
  useStartT1DIndexImportJob,
} from "api/features/import/queries";

// Contexts
import { useUserContext } from "contexts/contextUser";

function ImportForm(): JSX.Element {
  const { isAuthenticated } = useUserContext();
  const isAuth = Boolean(isAuthenticated);

  return (
    <ImportActiveJobProvider>
      <MDBox>
        {isAuth && (
          <UploadFileForm
            label="Country Info File"
            useStartImportJobFunc={useStartCountryInfoImportJob}
          />
        )}
        {isAuth && (
          <UploadFileForm
            label="Country Demo File"
            useStartImportJobFunc={useStartCountryDemoImportJob}
          />
        )}
        {isAuth && (
          <UploadFileForm
            label="T1D Index File"
            useStartImportJobFunc={useStartT1DIndexImportJob}
          />
        )}
      </MDBox>
    </ImportActiveJobProvider>
  );
}

export default ImportForm;
